export const LOCAL_STORAGE_SIDEBAR_COLLAPSED_KEY = 'isSidebarCollapsed';
